define('presentation/signupPackagePicker/presentationObjects/signupPackagePresentationObject',[
], function () {
    return function () {
        const self = this;

        self.billingPackageId = null;
        self.packageId = "";
        self.type = 0;
        self.sequence = 0;
        self.name = "";
        self.description = "";
        self.price = "";
        self.pricePerMonth = "";

        self.isMostPopular = false;
        self.isOnboardingRequired = false;
        self.isRetired = false;
        self.isUpgradable = false;
        self.isSignatureService = false;

        self.includedChatSessions = null;
        self.pricePerAdditionalChatSession = null;

        self.includedOutboundContacts = null;
        self.pricePerAdditionalOutboundContact = null;

        self.includedMinutes = null;
        self.pricePerAdditionalMinute = null;

        self.includedPhoneNumbers = null;
        self.pricePerAdditionalPhoneNumber = null;

        self.includedScripts = null;
        self.pricePerAdditionalScript = null;

        self.includedUsers = null;
        self.pricePerAdditionalUser = null;

        self.outboundCallingSetupFee = null;
        self.smsSetupFee = null;

        self.isCurrent = ko.observable(false);
        self.isSelected = ko.observable(false);
        self.isSelectable = ko.observable(true);
    };
});
